import { Select } from "antd";
import React from "react";
import { ADMINISTRATOR_STATUS_INFO } from "../../../constants/constant";

const AdministratorStatus = (props) => {
    return (
        <>
            <Select
                {...props}
                style={{ width: "150px" }}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                allowClear
            >
                {ADMINISTRATOR_STATUS_INFO?.map((data) => {
                    return (
                        <Select.Option key={data?.id} value={data.value}>
                            {data?.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default AdministratorStatus;
